export var ClientId = "757435679763-7jet8ofntrurjrjf4obvn9t5v86ljvmf.apps.googleusercontent.com"